import { render, staticRenderFns } from "./TheResourceAdd.vue?vue&type=template&id=eda2c0b4&scoped=true&"
import script from "./TheResourceAdd.vue?vue&type=script&lang=js&"
export * from "./TheResourceAdd.vue?vue&type=script&lang=js&"
import style0 from "./TheResourceAdd.vue?vue&type=style&index=0&id=eda2c0b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda2c0b4",
  null
  
)

export default component.exports